<ion-item-group>
  <ion-item-divider sticky>
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/domain_24dp.svg"
    ></ion-icon>
    <div>
      <p class="subtitle">{{ 'register.sections.company' | translate }}</p>
    </div>
  </ion-item-divider>

  <div [formGroup]="form()">
    <ion-grid class="ion-padding">
      <ion-row>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="companyName"
            label="{{ 'register.labels.company_name' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.company_name' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
            [errorText]="getErrorMessage('companyName') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="companyTaxId"
            label="{{ 'register.labels.company_tax_id' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.company_tax_id' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
            [errorText]="getErrorMessage('companyTaxId') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="8"
          size="12"
        >
          <ion-input
            formControlName="companyStreet"
            label="{{ 'register.labels.company_street' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.company_street' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
            [errorText]="getErrorMessage('companyStreet') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="4"
          size="12"
        >
          <ion-input
            formControlName="companyPostalCode"
            label="{{ 'register.labels.company_postal_code' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.company_postal_code' | translate }}"
            fill="outline"
            mode="md"
            maxlength="5"
            [clearInput]="true"
            [errorText]="getErrorMessage('companyPostalCode') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="companyCity"
            label="{{ 'register.labels.company_city' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.company_city' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
            [errorText]="getErrorMessage('companyCity') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-select
            formControlName="companyCountryCode"
            label="{{ 'register.labels.company_country' | translate }}"
            interface="popover"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.company_country' | translate }}"
            fill="outline"
            mode="md"
            multiple="false"
          >
            @for (country of countries(); track country.isoCode) {
              <ion-select-option [value]="country.isoCode">{{ country.name }}</ion-select-option>
            }
          </ion-select>
        </ion-col>
        <ion-col
          size-lg="4"
          size="6"
        >
          <ion-item lines="none">
            <ion-checkbox
              formControlName="isCarrier"
              label-placement="end"
              >{{ 'register.labels.is_carrier' | translate }}</ion-checkbox
            >
          </ion-item>
        </ion-col>
        <ion-col
          size-lg="4"
          size="6"
        >
          <ion-item lines="none">
            <ion-checkbox
              formControlName="isShipper"
              label-placement="end"
              >{{ 'register.labels.is_shipper' | translate }}</ion-checkbox
            >
          </ion-item>
        </ion-col>
      </ion-row>

      @if (form().hasError('atLeastOneCheckboxRequired') && (form().touched || form().dirty)) {
        <div class="errors">
          {{ 'register.error.role_required' | translate }}
        </div>
      }
    </ion-grid>
  </div>
</ion-item-group>
